/**
 * Comment
 */

import Config from '../../Config';
import Util from '../../Util';
import InfiniteScroll from '../../InfiniteScroll';
import Template from '../Template';
import Loading from '../../Loading';

class CommentMore {

	public onMore: any;

	private loading: Loading;

	private moreSelector: string;

	private $node: any;

	private _id: string;

	private articleId: string;

	private orderType: string;

	constructor( $node: any, articleId: string ) {
		this.$node = $node;
		this._id = this.$node.attr( 'id' );
		this.articleId = articleId;
		this.orderType = Config.orderType;

		this.addEvent();

		this.loading = new Loading( this.$node );
		this.moreSelector = `#${this._id} .ncCommmentMore`;
		this.onMore = new Util.Observer();
	}

	public get() {
		this.loading.show();

		const articleId = this.articleId || Util.getParams().articleId;
		const commentId = jQuery( `#${this._id} .comment-article:last` ).attr( 'data-commentid' );
		const commentMoreUrl = Util.Tmpl.render({
			data: {
				articleId,
				commentId,
				board: Config.board,
				moreSize: Config.commentListSize,
				moreDirection: 'BEFORE',
				orderType: this.getOrderType(),
			},
			template: Config.commentMoreVote,
		});

		const commentMore = Util.get( commentMoreUrl );
		const commentMore$ = Util.from( commentMore );
		commentMore$.subscribe( ( data: any ) => {

			data = Util.convertCamelCase( data );

			if ( data.listMoreCommentEntries ) {
				data.commentList = data.listMoreCommentEntries.commentList;
				data.hasMore = data.listMoreCommentEntries.hasMore;
				data.likeCommentIds = data.listMoreCommentEntries.likeCommentIds;
				data.dislikeCommentIds = data.listMoreCommentEntries.dislikeCommentIds;
			}

			if ( !data.hasMore ) {
				this.remove();
			}

			this.onMore.emit( data );
			this.loading.hide();

		}, () => {
			this.loading.hide();
		});
	}

	public getVote() {
		const articleId = this.articleId || Util.getParams().articleId;
		const commentVoteUrl = Util.Tmpl.render({
			data: {
				articleId,
				board: Config.board,
				size: Config.commentListSize,
			},
			template: Config.commentMoreVote,
		});
		const commentVote = Util.get( commentVoteUrl );
		const commentVote$ = Util.from( commentVote );
		commentVote$.subscribe( ( data: any ) => {
			// resolve
		}, () => {
			// reject
		});
	}

	public setUI() {
		return `<button class="ncCommmentMore"><span class="txt">${Config.L10N.btn_more}</span></button>`;
	}

	public remove() {
		jQuery( this.moreSelector ).hide();
	}

	public showMoreButton() {
		jQuery( this.moreSelector ).show();
	}

	public setOrderType( orderType: string ) {
		this.orderType = orderType;
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', `#${this._id} .ncCommmentMore`, ( evt ) => {
			this.get();
			this.loading.setUI();
		});
	}

	private getOrderType() {

		// Not using comment orderType, default type is DESC
		if ( !Config.isShowCommentOrderType ) {
			return Config.commentOrderByDesc;
		}

		return this.orderType;
	}
}

export default CommentMore;
